import Nullstack from 'nullstack';
export default function IconArrowBearRight2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-bear-right-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 3h5v5"
  }), "   ", Nullstack.element("path", {
    d: "M20 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
  }), "   ", Nullstack.element("path", {
    d: "M4 5l4.5 4.5"
  }), " ");
}